import { Directive, ElementRef, Input} from '@angular/core';
import { HTML } from '../utils/html';

@Directive({
  selector: '[trimRichtextTitle]'
})
export class TrimRichtextTitleDirective {

  @Input() set trimRichtextTitle(content: string) {
    this.elementRef.nativeElement.title = HTML.trim(content);
  }

  constructor(protected elementRef: ElementRef) {
  }
}